
/**
 * Remplace les placeholders d'une URL par les valeurs des paramètres. Destiné aux path params.
 * @param url Le templace d'URL à modifier
 * @param placeholderValues Objet contenant les placeholders en clé et les paramètres en valeur
 * @returns {void|*|string}
 */
export function replaceUrlPlaceholders(url, placeholderValues) {

    let finalUrl = url;

    if (placeholderValues) {
        for (let placeholder of Object.keys(placeholderValues)) {
            finalUrl = finalUrl ? finalUrl.replace(':' + placeholder, placeholderValues[placeholder]) : '';
        }
    }

    return finalUrl;
}

export function decodeEntities(encodedString) {

    if (encodedString === null || encodedString === undefined) {

        return ''

    } else {

        const textArea = document.createElement('textarea');
        textArea.innerHTML = encodedString;
        return textArea.value;
    }
}